import { SurveyInterface } from 'app/assessment/survey/models';

export interface SurveyStateInterface {
  ids?: number[];
  surveys?: { [id: number ]: SurveyInterface };
  selectedSurvey?: number;
  surveyProgress?: number;
  currentSurvey?: SurveyInterface;
}

export class SurveyState implements SurveyStateInterface {
  public ids?: number[];
  public surveys?: { [id: number ]: SurveyInterface };
  public selectedSurvey?: number | null;
  public surveyProgress?: number | null;
  public currentSurvey?: SurveyInterface | {};

  constructor({
    ids = undefined,
    surveys = undefined,
    selectedSurvey = undefined,
    surveyProgress = undefined,
    currentSurvey = undefined,
    }: SurveyStateInterface) {
    this.ids = ids;
    this.surveys = surveys;
    this.selectedSurvey = selectedSurvey;
    this.surveyProgress = surveyProgress;
    this.currentSurvey = currentSurvey;
  }
}
